import React from 'react';
import PaymentTransactionDemo from '@/components/demo/PaymentTransactionDemo';

const BillingDemoPage: React.FC = () => {
  return <PaymentTransactionDemo />;
};

export default BillingDemoPage;